import { AxiosResponse } from 'axios';

import { BTVProgrammesResponse } from 'store/railsBuilder/reducer.types';

function isBtvProgrammesResponse(
    response: any,
): response is AxiosResponse<BTVProgrammesResponse> {
    return Array.isArray(response?.data?.programmes);
}

export default isBtvProgrammesResponse;
